import {
  Container,
} from "react-bootstrap";

const FooterSection = ({footerSection, headerSection, ICON_MAP, sendNotification}) => {
  return (
    <>
      <Container>
        <footer className="py-3 text-center text-muted hstack gap-2 justify-content-between">
          <span>© {new Date().getFullYear()} {headerSection?.pageName}{footerSection?.footerAdditionalText && ` | ${footerSection?.footerAdditionalText}`}</span>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 16,
              fontSize: 18,
            }}
          >
            {(footerSection?.socialLinks || [])?.map((item, index) => {
              const IconComponent = ICON_MAP[item.icon];
              return (
                <a
                  title={item?.title}
                  key={index}
                  href={item?.url}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => sendNotification("notification", `Visitor Navigated to the ${item?.title} Social Link`)}
                >
                  <IconComponent color={item?.color} />
                </a>
              );
            })}
          </div>
        </footer>
      </Container>
    </>
  );
};

export default FooterSection;
